module.exports = __webpack_public_path__ + "static/img/logo-footer.65290a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-footer.svg
// module id = nak5
// module chunks = 2